module.exports = __webpack_public_path__ + "materialdesignicons-webfont.woff?d6e3eba9b16453f51d4ef6e216bf89ff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.woff?v=4.7.95
// module id = 1216
// module chunks = 0